import React, { useRef, useState, useEffect } from 'react'
import styles from './IssueType.module.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import API from '../../../ApiConfig'
import { BASE_URL, GET_ALL_COMPLETED_DOCS_ISSUER_ID, USER_TOKEN } from '../../../Utils/constant'
import { Delay, _ToNormal } from '../../../Utils/helper';
import cogoToast from 'cogo-toast-react-17-fix';
import useRefreshToken from '../../../Hooks/usegenerateToken';
import { Icon } from 'react-icons-kit';
import { file } from 'react-icons-kit/feather/file'
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import Breadcrumb from '../../../components/Verifier/breadcrumb/BreadCrumb';
import IssuerNavigator from '../../../components/DashBoard/IssuerNavigator';
import NavLinks from '../../../components/NavLinks';
import { useSelector } from 'react-redux';

const SelectIssueDoc = ({ handleStep, setDoc, ISSUER_ID }) => {
  useRefreshToken(BASE_URL + USER_TOKEN)
  const [docsList, setDocsList] = useState([])
  const [apiData, setApiData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedOption, setSelectedOption] = useState();
  const User=useSelector(state=>state.User)

  const location = useLocation();
  const navigate = useNavigate();
  // console.log(location);
  const master_doc_id=location?.state?.master_document_id
  const templateId = location?.state?.documentId || null;

  useEffect(() => {
    setLoading(true);
    let doc = docsList.filter(e => e.id == templateId)
    // console.log(doc);
    setSelectedOption(doc[0])
    setDoc(doc[0])
    setLoading(false);
  }, [docsList, templateId])

  const handleSelect = (option) => {
    setSelectedOption(option);
    setDoc(option)
    handleStep(2)
  };

  useEffect(() => {
    getDocsList()
  }, [])

  async function getDocsList() {
    setLoading(true)
    const URL=master_doc_id? GET_ALL_COMPLETED_DOCS_ISSUER_ID + ISSUER_ID + "?master_document_id=" +master_doc_id :GET_ALL_COMPLETED_DOCS_ISSUER_ID + ISSUER_ID
    API.get(URL)
      .then(res => {
        setLoading(false)
        if (res.status === 200) {
          setApiData(res.data.data)
        }
      })
      .catch(err => {
        setLoading(false)

        cogoToast.error(err.message)
      })
  }

  // tabs
  const [MenuLinks, setMenuLinks] = useState([
    { name: "Custom Templates", link: 1 },
    { name: "Master Templates", link: 0 }
  ])
  const [activeTab, setActiveTab] = useState({ name: "Custom Templates", link: 1 })


  function handleActiveTab(e) {
    setActiveTab(e)
  }

  useEffect(() => {
    if(apiData && apiData.length>0){
      let lst = apiData.filter(e => {
        return e.doc_type == activeTab.link;
      })
      setDocsList(lst);

    }
  }, [activeTab, apiData])

  // if (selectedOption?.id) {
  //   navigate('/dashboard/details', { state: { selectedOption } })
  // }

  const Card = ({ doc }) => {
    // console.log(doc);

    if (doc)
      return (
        <div onClick={e => handleSelect(doc)} className='issuer-container container justify-content-flex-start navItemContainer' style={{ cursor: 'pointer', alignItems: 'center', margin: 0 }}>
          <div className={styles.icon} style={{ padding: '0.5rem', height: '2rem', width: '2rem' }}>
            <Icon icon={file} />
          </div>
          <div>
            <div className={styles.title}>
              {doc.doc_name}

            </div>
            {doc.master_doc_name}
          </div>

        </div>
      )
    else {
      return (
        <div>No Template Found</div>
      )
    }
  }

  const createNewTemplate = () => (
    <div className="navItemContainer">
      {User.user_type=="Super Admin"?null:<button className="btn btn-primary" onClick={e => navigate('/dashboard/TemplateType')} style={{ width: '13rem' }}>+ Create New Template</button>}
    </div>
  )

  return (

    <div style={{width:"100%"}}>
      <SlideUpWrapper>
        <Breadcrumb pos={1} title={'Choose Document'} category={'issuer'} />
        <IssuerNavigator
          title={'Choose Template'}
          step={'../credentials'}
          actions={createNewTemplate}
        />
        <div className='issuer-container container justify-content-flex-start navItemContainer' style={{ flexDirection: 'column' }}>
          <NavLinks loading={loading} MenuLinks={MenuLinks} menuClick={handleActiveTab} ischangeRequested={false} />
          <div className='container' style={{marginLeft:"0px"}}>
            <div className='justify-content-flex-start navItemContainer' style={{ flexWrap: 'wrap' }}>
              {docsList.length > 0 ? docsList.map(i => <Card doc={i} />) : [...Array(1)].map((_, index) => <Card doc={0} />)}
            </div>
          </div>
        </div>
      </SlideUpWrapper>
    </div>
  )
}

export default SelectIssueDoc
